<div class="otp-confirmation-wrapper">
  <div class="otp-confirmation-card">
    <img [src]="logoPath" alt="Nevada Department of Education Logo" class="otp-logo-header">
    <div class="otp-divider"></div>
    <div class="otp-content">
      <div class="otp-title">Email Address on File</div>
      <div class="otp-description">
        We found an account associated with the recovery email you provided.
      </div>
      <div class="otp-description">
        For your privacy, only part of the email is shown.
      </div>
      <div class="otp-email-box">
        <input type="text" class="otp-email-input" placeholder="" />
      </div>
    </div>
    <div class="otp-next-title ml-0">What would you like to do next?</div>
    <div class="otp-actions">
      <button class="otp-btn" (click)="onResetPassword()">Reset Password</button>
      <button class="otp-btn" (click)="onLogIn()">Log In With This Email</button>
    </div>
  </div>
</div>